export class QueryParamsModel {
	page: string;
	constructor(
		public filter: any[] = [],
		public sortDirection: 'asc' | 'desc' = 'asc',
		public sortField: string = '',
		public offset: number = 0,
		public limit: number = 15,
		public all: boolean = false,
		public columns: string = ''
	) {}

	toUrlParams(): string {
		// Base paging params.
		this.page = `?offset=${this.offset}&limit=${this.limit}`;

		// Build filter param.
		let filters = '';
		if (this.filter && this.filter.length > 0) {
			filters = `&filter=${this.filter.join(',')}`;
		}

		// Build sorting param.
		let sorting = '';
		if (this.sortField && this.sortField.length > 0) {
			sorting = `&sortField=${this.sortField}&sortDirection=${this.sortDirection}`;
		}

		// Build columns param.
		let columnsParam = '';
		if (this.columns && this.columns.length > 0) {
			// Use encodeURIComponent to handle any special characters.
			columnsParam = `&columns=${encodeURIComponent(this.columns)}`;
		}

		// Combine the base paging params, filters, sorting, and columns.
		const baseParams = this.page + filters + sorting + columnsParam;

		// If the 'all' flag is set, add it to the params.
		return this.all ? baseParams + '&all=true' : baseParams;
	}
}
